import React from 'react';
import Immutable from 'immutable';
import {Provider} from 'react-redux';
import {configureStore} from '../config/';
import reducers from './module';
import Reviews from './Reviews';

class Index extends React.Component {

    constructor(props) {
        super(props);

        const initialState = Immutable.fromJS(props.initialState) || {};

        this.store = configureStore(initialState, reducers);
    }

    render() {
        return (
            <Provider store={this.store}>
                <Reviews/>
            </Provider>
        );
    }
}

export default Index;



// WEBPACK FOOTER //
// ./src/reviews/index.js